import React, { useState,useMemo} from 'react'
import {Select, Box,Grid, TextField,Button,Card,Divider,useMediaQuery, Container,IconButton,OutlinedInput, FormHelperText,
    FormControl,InputLabel,InputAdornment,MenuItem,Autocomplete,Checkbox,FormControlLabel,FormGroup,Tooltip } from '@mui/material';
import { Typography } from 'material-ui';
import { useDispatch,useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { fetchData, postData } from '../../../redux/apiSlice';
import swal from "sweetalert";
import { Formik } from 'formik';
import * as Yup from 'yup';
import InputMask from 'react-input-mask';
import axios from 'axios';
import config from "../../../AppConfig";
import formatPhoneNumber from '../../../Components/Formats/PhoneNumberValidation';
import MaterialReactTable from 'material-react-table';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Freez from '../../../Components/Loader/Loader';
import Backdrop from '@mui/material/Backdrop';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

let RequestFormInitialValues = {
//   firstname: '',
//   lastname: '',
  name: '',
  companyName: '',
  phone: '',
  email : '',
  communicationEmail : '',
  companyId : '',
  attendance : false,
  city : '',
  zipCode : '',
};

function NYCEvetAttendance(props) {
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const [registerEmail, setRegisterEmail] = useState('');
    const [emailError, setEmailError] = useState("");
    const [isAffiliate,setIsAffiliate] = useState("Yes");
    const [showForm,setShowForm] = useState(false);
    const [mainForm,setMainForm] = useState(true);
    const [disableCheck,setDisableCheck] = useState(false);
    const [btn,setBtn] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const [options, setOptions] = useState([]);
    const [attendanceError, setAttendanceError] = useState('');
    const [notInList, setNotInList] = useState(false);
    const [showfirstList, setShowFirstList] = useState(false);
    const [showSecondList, setShowSecondList] = useState(false);
    const [list1, setList1] = useState([]);
    const [list2, setList2] = useState([]);
    const navigate = useNavigate();
    const [freez, setFreez] = React.useState(false);

    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    const accountSchema = Yup.object() .shape({
        // firstname: Yup.string()
        //                 .min(2, 'Too Short!')
        //                 .max(50, 'Too Long!')
        //                 .required('Please enter your full Name.'),
            
        // lastname: Yup.string()
        //             .min(2, 'Too Short!')
        //             .max(50, 'Too Long!')
        //             .required('Please enter your last Name.'),
        name: Yup.string()
                    .min(2, 'Too Short!')
                    .max(50, 'Too Long!')
                    .required('Please enter Name.'),
        email: Yup.string()
                .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
                .required('Please enter email address.'),
        // communicationEmail: Yup.string()
        //         .matches(/^(?:[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24})$/i, "Invalid email format.")
        //         .required('Please enter email address.'),
       phone: Yup.string()
            .nullable() // allows null values
            .notRequired() // makes the field optional
            .test(
                'is-10-digits',
                'Must be 10 digits.',
                (value) => {
                if (!value) return true; // Skip validation if field is empty
                return value.replace(/\D/g, '').length === 10;
                }
            ),
                // .required('Please enter mobile number.'),
        companyName :   Yup.string()      
                    .required('Please enter company name.'),
        city: Yup.string()
                .nullable()
                .min(2, 'Too Short!')
                .max(50, 'Too Long!'),
        zipCode: Yup.string()
                .nullable()
                .notRequired()
                .test('len', 'Must be 5 digits', val => !val || val.length === 5)
       
    });

    const validateEmail = (email) => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    
            if (!email) {
                return "Please enter email address.";
            } 
            if (!emailRegex.test(email)) {
                return "Invalid email format."; 
            }
            return "";
    };


    const validateRegisterEmail = async() => {
    // var myEmail = event.target.value;
    const errorMessage = validateEmail(registerEmail);
    setEmailError(errorMessage);
    
    
    if (errorMessage) {
        return;
    }

    const apiUrl = '/get-nyc-email-details'; // Replace with your API endpoint
    const args = {
        email : registerEmail,
        internal: 1,
    };
    try{
    const res = await dispatch(postData({ apiUrl, args })).unwrap();
    if(res){
        if(res.success === true) {
        // RequestFormInitialValues.firstname = res.data.first_name;
        // RequestFormInitialValues.lastname = res.data.last_name;
        RequestFormInitialValues.name = res.data.first_name;
        RequestFormInitialValues.email = res.data.communication_email;
        RequestFormInitialValues.phone = res.data.phone;
        RequestFormInitialValues.companyName = res.data.company_name ? res.data.company_name : '';
        RequestFormInitialValues.companyId = res.data.company_master_id;
        RequestFormInitialValues.city = res.data.city;
        RequestFormInitialValues.zipCode = res.data.zip_code;
        // console.log("RequestFormInitialValues:"+JSON.stringify(RequestFormInitialValues));
        setShowForm(true);
        setDisableCheck(true);
        // setDisableBtn(true);
        }else{
            swal({
                title: "Failed",
                text: res.message,
                icon: "error",
                button: "Ok",
            })
        }
    }
    }catch (error) {
        console.error("Error validating email:", error);
    }
    
    };

    const handleInputChange = async (event, newInputValue) => {
        setRegisterEmail(newInputValue);

        if (newInputValue.length >= 1) {
        // setLoading(true);
        try {
            // Call your API with the search string
            const response = await axios.get(`${config.API_BASE_URL}` + `/search-nyc-event-emails?search=${newInputValue}`);
            setOptions(response.data.data); // assume API returns an array of emails
        } catch (error) {
            console.error('Error fetching emails:', error);
        } finally {
            // setLoading(false);
        }
        }
    };

    const CreateUser = async(values,{ resetForm }) => {
        // console.log("attendance:", values.attendance);
        // if(values.attendance == false) {
        //     setAttendanceError("Please Check In");
        //      return ;
        // }
        // setBtn(true);
        const apiUrl = '/add-nyc-event-attendance'; // Replace with your API endpoint
        const args = {
            email : values.email,
            // communicationEmail : values.communicationEmail,
           
            // firstname : values.firstname,
            // lastname : values.lastname,
            name:values.name,
            phone : values.phone, 
            companyName : values.companyName, 
            // companyId : values.companyId,
            city : values.city,
            zipCode : values.zipCode,
            attendance : values.attendance
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if(res){
        //   handleFreezStop();
            if(res.success === true) {
            // setTimeout(function () {
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
                // resetForm();

                setRegisterEmail('');
            // }, 5000);
            // setBtn(false);
            setTimeout(() => {
                window.location.reload();
            }, 2000); 
            
             // }
            }else{
                // setBtn(false);
                // setDisableBtn(false);
                setShowForm(false);
                let errorMessages = "";
                if (typeof res.message === "string") {
                    // Case 1: Message is a plain string
                    errorMessages = res.message;
                } else if (typeof res.message === "object") {
                    // Case 2: Message is an object (with arrays)
                    errorMessages = Object.values(res.message).flat().join("\n");
                }
                swal({
                    title: "Failed",
                    text: errorMessages,
                    icon: "error",
                    button: "Ok",
                });
            }
        }
        };

    const addNYCEventAttendanceDirectly = async(email) => {
        handleFreezStart();
        const apiUrl = '/add-nyc-event-attendance-directly'; // Replace with your API endpoint
        const args = {
            email : email,
        };
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if(res){
            if(res.success === true) {
            // setTimeout(function () {
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
                // resetForm();

                setRegisterEmail('');
            // }, 5000);
            // setBtn(false);
            setTimeout(() => {
                getNonAttendees(1);
                getAttendees(1);
            }, 2000); 
            handleFreezStop();
             // }
            }
        }
        };
    const getAttendees = async(refresh) => {
        if(!showfirstList || refresh == 1){
            const apiUrl = '/get-nyc-event-attendees';
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res) {
                setList1(res.data);   
            }
        }
        if(refresh == 0) {
            setShowFirstList(!showfirstList);
        }
    }
    const getNonAttendees = async(refresh) => {
        if(!showSecondList || refresh == 1){
            const apiUrl = '/get-nyc-event-non-attendees';
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            if (res) {
                setList2(res.data);   
            }
        }
        if(refresh == 0) {
            setShowSecondList(!showSecondList);
        }
    }

    const columns = useMemo(
          //column definitions...
          () => [
            {
              accessorKey: 'company_name',
              accessorFn: (row) => `${row.company_name ? row.company_name : ''}`,
              id:'companyName',
              header: 'Company Name',
              size: 50,
            },
            {
              accessorKey: 'first_name',
              accessorFn: (row) => `${row.first_name ?  row.first_name : '' }`,
              id:'Name',
              header: 'Name',
              size: 50,
            },
            {
              accessorKey: 'email',
              accessorFn: (row) => `${row.email ? row.email : '' }`,
              id:'email',
              header: 'Email',
              size: 50,
            },
            {
              accessorKey: 'phone_no',
              accessorFn: (row) => `${row.phone ?  ((row.phone !== '' && row.phone != null && row.phone != '0' ? row.phone : 'N/A') ): 'N/A'  }`,
              id:'phone',
              header: 'Phone No.',
              size: 50,
              Cell:({renderedCellValue,row}) =>(row.original.phone ?  ((row.original.phone !== '' && row.original.phone != null && row.original.phone != '0' ? formatPhoneNumber(row.original.phone ): 'N/A') ): 'N/A' ),
            },
            {
              accessorKey: 'city',
              accessorFn: (row) => `${row.city ? row.city : 'N/A'  }`,
              id:'city',
              header: 'City',
              size: 50,
            },
           {
              accessorKey: 'zip_code',
              accessorFn: (row) => `${row.zip_code ? row.zip_code : 'N/A'  }`,
              id:'zipCode',
              header: 'Zip-Code',
              size: 50,
            },
    ]);

    const columns2 = useMemo(
          //column definitions...
          () => [
            {
              accessorKey: 'company_name',
              accessorFn: (row) => `${row.company_name ? row.company_name : ''}`,
              id:'companyName',
              header: 'Company Name',
              size: 50,
            },
            {
              accessorKey: 'first_name',
              accessorFn: (row) => `${row.first_name ?  row.first_name : '' }`,
              id:'Name',
              header: 'Name',
              size: 50,
            },
            {
              accessorKey: 'email',
              accessorFn: (row) => `${row.email ? row.email : '' }`,
              id:'email',
              header: 'Email',
              size: 50,
            },
            {
              accessorKey: 'phone_no',
              accessorFn: (row) => `${row.phone ?  ((row.phone !== '' && row.phone != null && row.phone != '0' ? row.phone : 'N/A') ): 'N/A'  }`,
              id:'phone',
              header: 'Phone No.',
              size: 50,
              Cell:({renderedCellValue,row}) =>(row.original.phone ?  ((row.original.phone !== '' && row.original.phone != null && row.original.phone != '0' ? formatPhoneNumber(row.original.phone ): 'N/A') ): 'N/A' ),
            },
            {
              accessorKey: 'city',
              accessorFn: (row) => `${row.city ? row.city : 'N/A'  }`,
              id:'city',
              header: 'City',
              size: 50,
            },
           {
              accessorKey: 'zip_code',
              accessorFn: (row) => `${row.zip_code ? row.zip_code : 'N/A'  }`,
              id:'zipCode',
              header: 'Zip-Code',
              size: 50,
            },
            {
                accessorFn: (data) => `${data}`,
                id: 'action',
                header: 'Action',
                enableSorting: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                <Box>
                    <>
                    {/* <Tooltip ><AddCircleIcon onClick={() => addNYCEventAttendanceDirectly(row.original.email)}/></Tooltip> */}
                    <button style={{ 
                        background: 'none', 
                        border: 'none', 
                        color: '#007bff', 
                        textDecoration: 'none', 
                        cursor: 'pointer', 
                        padding: 0,
                        font: 'inherit'
                    }}
                    onClick={() => addNYCEventAttendanceDirectly(row.original.email)}>Check-In </button>
                    </>
                </Box>
                ),
        
            }
    ]);

    const csvOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      fileName: 'NYC Event Attendees List',
      headers: ['Company Name', 'Name', 'Email','Phone No.','City','Zip Code'],
    };

    const csvOtherOptions = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: false,
      fileName: 'NYC Event Others List',
      headers: ['Company Name', 'Name', 'Email','Phone No.','City','Zip Code'],
    };

    const convertToCSV = (data, type) => {
        var headers;
        if(type == 'type1') {
            headers = csvOptions.headers.join(',') + '\n';
        }else{
            headers = csvOtherOptions.headers.join(',') + '\n';
        }
        
    
        const rows = data.map((row) => {
        return Object.values(row).map((value) => {
            // Handle any necessary formatting or escaping of values
            // For simplicity, we assume all values are already properly formatted
    
            // Replace newline characters with spaces
            if (typeof value === 'string') {
            value = value.replace(/\n/g, ' '); // Replace newline characters with spaces
            }
    
            // Wrap the value with double quotes if it contains a comma or quote
            if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
            return `"${value.replace(/"/g, '""')}"`; // Escape double quotes by doubling them
            }
    
            return value;
        }).join(',');
        }).join('\n');
    
        return headers + rows;
    };

    const handleExportData = (data) => {
        const exportedData = data.map((row) => {
        
        return {
            companyName: `${row.original.company_name ?  row.original.company_name : ''}` || 'N/A',
            name: `${row.original.first_name ?  row.original.first_name : ''}` || 'N/A',
            email:  `${row.original.email ?  row.original.email : ''}` || 'N/A',
            phone: `${row.original.phone ?  row.original.phone : ''}` || 'N/A',
            city: `${row.original.city ?  row.original.city : ''}` || 'N/A',
            zipCode: `${row.original.zip_code ?  row.original.zip_code : ''}` || 'N/A',
        };
        });
    
        const csvContent = convertToCSV(exportedData, 'type1');
        // Create a Blob object from the CSV data
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    
        // Create a download link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = csvOptions.fileName + '.csv';
    
        // Append the link to the document body
        document.body.appendChild(link);
    
        // Programmatically click the link to trigger the file download
        link.click();
    
        // Clean up the temporary URL and remove the link from the document
        URL.revokeObjectURL(link.href);
        link.remove();
    };

    const handleExportData2 = (data) => {
        const exportedData = data.map((row) => {
        
        return {
            companyName: `${row.original.company_name ?  row.original.company_name : ''}` || 'N/A',
            name: `${row.original.first_name ?  row.original.first_name : ''}` || 'N/A',
            email:  `${row.original.email ?  row.original.email : ''}` || 'N/A',
            phone: `${row.original.phone ?  row.original.phone : ''}` || 'N/A',
            city: `${row.original.city ?  row.original.city : ''}` || 'N/A',
            zipCode: `${row.original.zip_code ?  row.original.zip_code : ''}` || 'N/A',
        };
        });
    
        const csvContent = convertToCSV(exportedData,'type2');
        // Create a Blob object from the CSV data
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    
        // Create a download link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = csvOptions.fileName + '.csv';
    
        // Append the link to the document body
        document.body.appendChild(link);
    
        // Programmatically click the link to trigger the file download
        link.click();
    
        // Clean up the temporary URL and remove the link from the document
        URL.revokeObjectURL(link.href);
        link.remove();
    };
    return (
        <>
            <Container maxWidth="md">
                <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",alignItems:'flex-end',marginTop:isMobile?"4%":"1%"}}>
                    <Grid item sx={{marginTop:"4%"}}>
                        {
                            isMobile?
                            <img src={require('../../../assets/images/NYE-Mobile.png')} style={{width:"60vw"}} />
                            :
                            <img src={require('../../../assets/images/NYE-Desktop.png')} style={{width:"30vw"}} />
                        }
                        
                    </Grid> 
                </Grid>                
            </Container>
            <Container maxWidth="sm">
                <Card sx={{boxShadow:"none",marginTop:isMobile?"4%":"2%"}}>
                    <Grid item Container lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",paddingBottom:"10px",color:"green"}}>
                        {/* <Typography style={{fontSize:"24px",color:"green"}}><b>Register </b></Typography> */}
                    </Grid>
                    {
                        isAffiliate == "Yes"?
                        <>
                           <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                            {
                                mainForm ?
                                <>
                                  <Autocomplete
                                    sx={{ width: '100%' }}
                                    freeSolo
                                    name="registerEmail"
                                    options={options}
                                    inputValue={registerEmail}
                                    onInputChange={handleInputChange}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        label="Please Enter RSVP Email Address " 
                                        fullWidth 
                                        margin='dense'
                                        variant="outlined"
                                        InputProps={{
                                            ...params.InputProps,
                                            endAdornment: (
                                            <>
                                                {/* {loading ? <CircularProgress size={20} /> : null} */}
                                                {params.InputProps.endAdornment}
                                            </>
                                            ),
                                        }}
                                        />
                                    )}
                                />
                                </> : ''
                            }
                          
                            </Grid>
                            {/* <Grid Container item sx={{textAlign: isMobile ? "center": "right"}} mt={1} lg={12} md={12} sm={12} xs={12}> */}
                            <Grid Container item mt={1} lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent: "space-between"}} gap={2}>
                                <Grid item lg={6} md={6} sm={6} xs={6}  sx={{textAlign: isMobile ? "center": "left"}}>
                                     <FormGroup >
                                        <FormControlLabel control={<Checkbox
                                            checked={notInList}
                                            disabled={disableCheck}
                                            onChange={(e) => {
                                                if(!notInList) {
                                                  setShowForm(true);
                                                  setMainForm(false);
                                                }else{
                                                    setShowForm(false);
                                                    setMainForm(true);
                                                }
                                                setNotInList(!notInList)
                                                
                                            }}

                                        />} label="Not In RSVP List" />
                                        {/* {attendanceError ? <div className='error'>{attendanceError}</div> : null} */}
                                    </FormGroup>   
                                </Grid>
                                <Grid item lg={6} md={6} sm={6} xs={6} sx={{textAlign: isMobile ? "center": "right"}}>
                                    {
                                        mainForm ?
                                        <>
                                            <Button variant="contained" color='warning' sx={{minWidth:213,backgroundColor:"#FF690B",color:"white",fontWeight:"bold", borderRadius:"7px"}} onClick={validateRegisterEmail} disabled={disableBtn}>Submit</Button>
                                        </> : ''
                                    }
                                    
                                </Grid>
                            </Grid>
                        </>
                        : ''
                    }
                    
                
                    {
                        showForm ?
                        <>
                        <Formik
                                    initialValues={RequestFormInitialValues}
                                    validationSchema={accountSchema}
                                    // onSubmit={async(values, { resetForm }) => {
                                    //     CreateUser(values);
                                    // }}
                                    onSubmit={CreateUser}
                                    >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm }) => (
                <>
                        <Grid Container item mt={1} lg={12} md={12} sm={12} xs={12}>
                            <Divider sx={{height:"0.5px",backgroundColor:"#757575"}} />
                        </Grid>
                        {/* <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="firstname" 
                            size="small" 
                            label="First Name" 
                            variant="outlined" 
                            fullWidth 
                            name="firstname"
                            onChange={handleChange('firstname')}
                            onBlur={handleBlur('firstname')}
                            value={values.firstname} 
                            margin='dense'
                            helperText={touched.firstname && errors.firstname ? errors.firstname : null}
                            error={touched.firstname && errors.firstname ? errors.firstname : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="lastname" 
                            size="small" 
                            label="Last Name" 
                            variant="outlined" 
                            fullWidth 
                            name="lastname"
                            onChange={handleChange('lastname')}
                            onBlur={handleBlur('lastname')}
                            value={values.lastname}  
                            margin='dense'
                            helperText={touched.lastname && errors.lastname ? errors.lastname : null}
                            error={touched.lastname && errors.lastname ? errors.lastname : null}
                            />
                        </Grid> */}
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="name" 
                            size="small" 
                            label="Name" 
                            variant="outlined" 
                            fullWidth 
                            name="name"
                            onChange={handleChange('name')}
                            onBlur={handleBlur('name')}
                            value={values.name}  
                            margin='dense'
                            helperText={touched.name && errors.name ? errors.name : null}
                            error={touched.name && errors.name ? errors.name : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                             <InputMask 
                             id="phone" 
                             mask='(999) 999-9999'
                             maskChar={null}
                             size="small" 
                             type="text"
                             label="Phone No" 
                             variant="outlined" 
                             fullWidth 
                             name="phone"
                             autoComplete="phone"
                            //  onChange={handleChange('phone')}
                            onChange={(e) => {
                                const numericValue = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                setFieldValue('phone', numericValue); // Set only numbers to Formik
                            }}
                             onBlur={handleBlur('phone')}
                             value={values.phone}  
                             margin='dense'
                             helperText={touched.phone && errors.phone ? errors.phone : null}
                             error={touched.phone && errors.phone ? errors.phone : null}>
                                {(inputProps) =>
                                    <TextField
                                        label="Phone Number" variant="outlined"
                                        {...inputProps}
                                    />
                                }
                             </InputMask>
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12} mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField 
                            id="outlined-basic" 
                            size="small" 
                            label="Company Name" 
                            variant="outlined" 
                            fullWidth 
                            name="companyName"
                            value={values.companyName}  
                            onChange={handleChange('companyName')}
                            onBlur={handleBlur('companyName')}
                            margin='dense'
                            helperText={touched.companyName && errors.companyName ? errors.companyName : null}
                            error={touched.companyName && errors.companyName ? errors.companyName : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField id="outlined-basic" 
                            size="small" 
                            label="Email" 
                            variant="outlined" 
                            fullWidth 
                            name="email"
                            value={values.email}  
                            onChange={handleChange('email')}
                            onBlur={handleBlur('email')}
                            margin='dense'
                            helperText={touched.email && errors.email ? errors.email : null}
                            error={touched.email && errors.email ? errors.email : null}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <TextField
                                name="city"
                                onChange={handleChange('city')}
                                value={values.city || ""}
                                onBlur={handleBlur('city')}
                                fullWidth
                                // size="small"
                                id="city"
                                label="City"
                                helperText={touched.city && errors.city ? errors.city : null}
                                error={touched.city && Boolean(errors.city)}
                            />
                        </Grid>
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{display:"flex",justifyContent:"center"}}>
                            <InputMask
                                mask='99999'
                                maskChar={null}
                                type="text"
                                fullWidth
                                // size="small"
                                id="zipCode"
                                label="Zip Code"
                                name="zipCode"
                                onChange={(e) => {
                                    handleChange('zipCode')(e);
                                }}
                                value={values.zipCode || ""}
                                onBlur={handleBlur('zipCode')}
                                autoComplete="zipCode"
                                helperText={touched.zipCode && errors.zipCode ? errors.zipCode : null}
                                error={touched.zipCode && Boolean(errors.zipCode)}
                                >
                                {(inputProps) =>
                                    <TextField
                                        label="Zip Code" variant="outlined"
                                        {...inputProps}
                                    />
                                    
                                }
                            
                            </InputMask>
                        </Grid>
                        {/* <Grid container item lg={12} md={12} sm={12} xs={12} >
                            <FormGroup >
                                <FormControlLabel control={<Checkbox
                                    checked={values.attendance}
                                    onChange={(e) => {
                                        if(!values.attendance) {
                                            setAttendanceError('');
                                        }
                                        setFieldValue('attendance', !values.attendance, true)
                                    }}

                                />} label="Check-In" />
                                {attendanceError ? <div className='error'>{attendanceError}</div> : null}
                            </FormGroup>
                        </Grid> */}
                        <Grid item Container lg={12} md={12} sm={12} xs={12}  mt={1}  sx={{textAlign: 'center'}}>
                            <Button variant="contained" color='warning' onClick={handleSubmit} disabled={btn}  sx={{minWidth:300,backgroundColor:"#FF690B",color:"white",fontWeight:"bold", borderRadius:"7px"}}>Check-In</Button>
                        </Grid>
                        </>
                    )}
                    </Formik>
                        </>
                        : ''
                    }
                   
                    <Grid Container item mt={2} lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent: "center"}} gap={2}>
                        <Grid item lg={6} md={6} sm={6} xs={6} >
                              <Button variant="contained" color="warning" sx={{ minWidth: 200 }} onClick={() => getNonAttendees(0)}>{showSecondList ? 'Hide RSVP List' : ' View RSVP List'}</Button>
                        </Grid>
                        <Grid item lg={6} md={6} sm={6} xs={6}  >
                             <Button variant="contained" color="warning" sx={{ minWidth: 200 }} onClick={() => getAttendees(0)}>{showfirstList ? 'Hide Checked-In' : 'View Checked-In'}</Button>
                        </Grid>
                       
                    </Grid>

                   
                     
                </Card> 
            </Container>
            <Container maxWidth="lg">
            <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent: "center", marginTop :"20px"}}>
                 {
                        showSecondList ?
                        <>
                         <Grid item lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",paddingBottom:"10px",color:"green"}}>
                            <Typography style={{color:"green",fontSize:"22px"}}><b>RSVP List </b></Typography>
                        </Grid>
                            
                            <MaterialReactTable
                                columns={columns2}
                                data={list2}
                                enableColumnFilterModes
                                filterFns={{
                                    customSearchFilterFn: (row, id, filterValue) =>
                                    row.getValue(id).toLowerCase().replace(/\s/g, '').includes(filterValue.toLowerCase().replace(/\s/g, '')),
                                }} 
                                globalFilterFn="customSearchFilterFn" //exact serach filter functionality
                                enableRowSelection={false}
                                positionToolbarAlertBanner="bottom"
                                enableDensityToggle={false}
                                enableColumnFilters={config.DatatableColumnFilter}
                                // onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                                // state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
                                initialState={{
                                    showColumnFilters: false,
                                    density: 'compact',
                                }}
                                // onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                                //top csv option
                                renderTopToolbarCustomActions={({ table }) => (
                                    <Box
                                    sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                                    >
                                    <Button
                                        color="primary"
                                        disabled={table.getPrePaginationRowModel().rows.length === 0}
                                        //export all rows, including from the next page, (still respects filtering and sorting)
                                        onClick={() =>
                                            handleExportData2(table.getPrePaginationRowModel().rows)
                                        }
                                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                        startIcon={<FileDownloadIcon />}
                                        variant="contained"
                                    >
                                        CSV
                                    </Button>

                                    </Box>
                                )
                                }
                            />
                        </>
                        : ''
                    }
            </Grid>
            <Grid Container item lg={12} md={12} sm={12} xs={12} sx={{justifyContent: "center", marginTop :"20px"}}>
                 {
                        showfirstList ?
                        <>
                         <Grid item lg={12} md={12} sm={12} xs={12} sx={{display:"flex",justifyContent:"center",paddingBottom:"10px",color:"green"}}>
                            <Typography style={{color:"green",fontSize:"22px"}}><b>Checked-In List </b></Typography>
                        </Grid>
                            
                            <MaterialReactTable
                                columns={columns}
                                data={list1}
                                enableColumnFilterModes
                                filterFns={{
                                    customSearchFilterFn: (row, id, filterValue) =>
                                    row.getValue(id).toLowerCase().replace(/\s/g, '').includes(filterValue.toLowerCase().replace(/\s/g, '')),
                                }} 
                                globalFilterFn="customSearchFilterFn" //exact serach filter functionality
                                enableRowSelection={false}
                                positionToolbarAlertBanner="bottom"
                                enableDensityToggle={false}
                                enableColumnFilters={config.DatatableColumnFilter}
                                // onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                                // state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
                                initialState={{
                                    showColumnFilters: false,
                                    density: 'compact',
                                }}
                                // onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                                //top csv option
                                renderTopToolbarCustomActions={({ table }) => (
                                    <Box
                                    sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                                    >
                                    <Button
                                        color="primary"
                                        disabled={table.getPrePaginationRowModel().rows.length === 0}
                                        //export all rows, including from the next page, (still respects filtering and sorting)
                                        onClick={() =>
                                            handleExportData(table.getPrePaginationRowModel().rows)
                                        }
                                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                        startIcon={<FileDownloadIcon />}
                                        variant="contained"
                                    >
                                        CSV
                                    </Button>

                                    </Box>
                                )
                                }
                            />
                        </>
                        : ''
                    }
            </Grid>
            
            </Container>
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                >
                    <Freez />
                </Backdrop>
            </div>
        </>
    )
    }

export default NYCEvetAttendance;